import React, { useContext } from 'react';
import { RouteItem } from '../../libs/IdeLink.Web.Common/src/types/RouteItem';
import { AppRouter } from '../routes/AppRouter';
import { getPage403Route } from '../scenes/Page403/Page403Route';

export type RouteContextType = {
    routes: RouteItem[];
    register: (moduleId: string, route: RouteItem[]) => void;
    unregister: (moduleId: string) => void;
    isRegistered: (moduleId: string) => boolean;
    isInitialized: boolean;
};

export const RouterContext = React.createContext<RouteContextType>({
    routes: [],
    register: () => {},
    unregister: () => {},
    isRegistered: () => false,
    isInitialized: false,
});

const initialRoutes: Record<string, RouteItem[]> = {
    global: [getPage403Route()],
};

export const RouteurContextProvider = ({ children }: React.PropsWithChildren<{}>) => {
    const [mapRoutes, setRoutes] = React.useState<Record<string, RouteItem[]>>(initialRoutes);
    const register = (moduleId: string, routes: RouteItem[]) => {
        setRoutes((r) => ({ ...r, [moduleId]: routes }));
    };
    const unregister = (moduleId: string) => {
        setRoutes((r) => {
            const { [moduleId]: _, ...rest } = r;
            return rest;
        });
    };

    const isRegistered = (moduleId: string) => {
        return Boolean(mapRoutes[moduleId]);
    };
    const routes = Object.keys(mapRoutes)
        .map((key) => mapRoutes[key])
        .flat() as RouteItem[];

    return (
        <RouterContext.Provider
            value={{
                routes,
                register,
                unregister,
                isRegistered,
                isInitialized: mapRoutes !== initialRoutes,
            }}
        >
            {children}
        </RouterContext.Provider>
    );
};

export const ModuleRouter = ({ defaultRoute }: { defaultRoute: string }) => {
    const routerContext = useContext(RouterContext);

    if (!routerContext.routes || !routerContext.isInitialized) {
        return null;
    }
    return <AppRouter routes={routerContext.routes} defaultRoute={defaultRoute} />;
};
